export const COA_RECLASSIFY_FORM_FIELD_IDS = {
  SELECTED_ACCOUNT: 'selected-account',
  CATEGORY: 'category'
};
